import { inject, Injectable } from '@angular/core';

import { I18nService } from '@core/i18n-legacy';
import type { DialogConfirmOptions } from '@core/user-interface-legacy';
import { SubscriptionService } from '@recruitee/company-logic';

type StatusChangeText = 'internal' | 'close' | 'retrieve';

type Model = Record<
  StatusChangeText,
  DialogConfirmOptions & {
    success: string;
    messageGdpr?: string;
  }
>;

@Injectable({
  providedIn: 'root',
})
export class StatusChangeTexts {
  protected readonly i18n = inject(I18nService);
  protected readonly subscription = inject(SubscriptionService);
  public readonly model: Model = {
    internal: {
      message: this.i18n.translate('app.offers.actions.unpublish.confirm_message.job'),
      title: this.i18n.translate('app.offers.actions.unpublish.confirm_title.job'),
      success: this.i18n.translate('app.offers.actions.unpublish.success_message.job'),
      agreeLabel: this.i18n.translate('app.offers.actions.unpublish.confirm_agree_label.job'),
      variant: 'information',
    },
    close: {
      message: this.i18n.translate(
        this.subscription.hasSlotsLimit()
          ? 'app.offers.actions.close.confirm_message.with_job_slots'
          : 'app.offers.actions.close.confirm_message.without_job_slots',
      ),
      title: this.i18n.translate('app.offers.actions.close.confirm_title.job'),
      success: this.i18n.translate('app.offers.actions.close.success_message.job'),
      agreeLabel: this.i18n.translate('app.offers.actions.close.confirm_agree_label.job'),
      variant: 'information',
    },
    retrieve: {
      message: this.i18n.translate('app.offers.actions.unarchive.confirm_message.job'),
      title: this.i18n.translate('app.offers.actions.unarchive.confirm_title.job'),
      success: this.i18n.translate('app.offers.actions.unarchive.success_message.job'),
      agreeLabel: this.i18n.translate('app.offers.actions.unarchive.confirm_agree_label.job'),
      variant: 'information',
    },
  };
}
